import { FilledButton } from '../../util/button';

interface NoInsuranceCardProps {
  onClick: () => void;
}
export const NoInsuranceCard = ({ onClick }: NoInsuranceCardProps) => {
  const label = '保険情報';
  const bodyText =
    '保険利用の有無について検討中を選択した方はこちらから登録することができます。';
  const noteText =
    '※ 保険の審査が入るので、お見積もりを再度行なってからの修理になります。';
  return (
    <div className={'information-card-no-insurance'}>
      <div className={'no-insurance-header'}>
        <span>{label}</span>
      </div>
      <div className={'no-insurance-body'}>
        <div className={'body-text'}>
          <span>{bodyText}</span>
        </div>
        <div className={'note-text'}>
          <span>{noteText}</span>
        </div>
      </div>
      <FilledButton label={'保険の情報を登録する'} onClick={onClick} />
    </div>
  );
};
